import global from './global';
// import lazyLoadInit from './modules/lazyload';

global.init();
// lazyLoadInit();
